import { Injectable } from '@angular/core';
import { SimuladorApi } from '@gestor-web/@core/api/ords';
import { TabelaTussIncorreta } from '@gestor-web/@core/api/ords/model';
import { map } from 'rxjs/operators';

export const TIPO_RELATORIO = 'MON_CR_GUIA_ITEM_TABELA_INC';

@Injectable()
export class TabelaTussIncorretaService {
  constructor(private simuladorApi: SimuladorApi) {}

  getData(regans: string, anobase: number) {
    return this.simuladorApi
      .fetchDadosJsonPreGerado<TabelaTussIncorreta>(regans, TIPO_RELATORIO, { anobase_competencia: anobase })
      .pipe(
        map(response => {
          const { items } = response;
          const { linhas } = items[0] ?? {};
          const atualizacao = items[0]?.dt_atualizacao;

          return {
            linhas,
            atualizacao,
          };
        }),
      );
  }
}
